import React from 'react';
import { Box, Typography } from '@mui/material';
import {
	StyledPageHeaderContainer,
	StyledBreadcrumbs,
	StyledBreadcrumbText,
	StyledBreadcrumbLink,
	BreadcrumbsContainer,
} from './styles';
import { BreadcrumbItem } from '../MainLayout';

interface PageHeaderProps {
	title: string;
	subtitle?: string;
	breadcrumbs?: BreadcrumbItem[];
	children?: React.ReactNode;
}

const PageHeader: React.FC<PageHeaderProps> = ({
	title,
	subtitle,
	breadcrumbs,
	children,
}) => {
	return (
		<Box>
			<StyledPageHeaderContainer>
				<Typography variant='h2' color='inherit'>
					{title}
				</Typography>
				{subtitle && (
					<Typography variant='body2' color='inherit'>
						{subtitle}
					</Typography>
				)}
				{children}
			</StyledPageHeaderContainer>
			{breadcrumbs && breadcrumbs.length > 1 && (
				<BreadcrumbsContainer>
					<StyledBreadcrumbs aria-label='breadcrumb'>
						{breadcrumbs.map((breadcrumb, index) => {
							const isLast = index === breadcrumbs.length - 1;
							return isLast ? (
								<StyledBreadcrumbText key={index}>
									{breadcrumb.label}
								</StyledBreadcrumbText>
							) : (
								<StyledBreadcrumbLink key={index} onClick={breadcrumb.onClick}>
									{breadcrumb.label}
								</StyledBreadcrumbLink>
							);
						})}
					</StyledBreadcrumbs>
				</BreadcrumbsContainer>
			)}
		</Box>
	);
};

export default PageHeader;
